export default [
  // 注册协议
  {
    path: 'agreement/registrationAgreement',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/pt/registrationAgreement').default);
        },
        'registrationAgreement',
      );
    },
    onEnter: () => {
      document.body.style.backgroundColor = '#f5f5f9';
    },
  },
  // 快捷登录协议
  {
    path: 'agreement/fastLoginAgreement',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/fastLoginAgreement').default);
        },
        'fastLoginAgreement',
      );
    },
  },
  // 法律责任及防范提示告知书
  {
    path: 'agreement/telnetWorkAgreement',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/telnetWorkAgreement').default);
        },
        'telnetWorkAgreement',
      );
    },
  },
  // 有账户协议
  {
    path: 'agreement/fastPayAccountAgreement',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/fastPayAccountAgreement').default);
        },
        'fastPayAccountAgreement',
      );
    },
  },
  // 无账户协议
  {
    path: 'agreement/fastPayAccountNoAgreement',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/fastPayAccountNoAgreement').default);
        },
        'fastPayAccountNoAgreement',
      );
    },
  },
  // 隐私保护协议
  {
    path: 'agreement/privacyProtectionAgreement',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(
            null,
            require('VIEW/agreement/pt/privacyProtectionAgreement').default,
          );
        },
        'privacyProtectionAgreement',
      );
    },
  },
  // 快捷通费率标准
  {
    path: 'agreement/chargeAgreement',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/chargeAgreement').default);
        },
        'chargeAgreement',
      );
    },
  },
  // 账户等级说明
  {
    path: 'agreement/accountLevel',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/accountLevel').default);
        },
        'accountLevel',
      );
    },
  },
  // 指纹支付协议
  {
    path: 'agreement/fingerPrint',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/fingerPrintAgreement').default);
        },
        'fingerPrintAgreement',
      );
    },
    onEnter: () => {
    },
  },
  {
    path: 'agreement/realNameAuthAgreement',
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/pt/realNameAuth').default);
        },
        'realNameAuthView',
      );
    },
    onEnter: () => {
    },
  },
  {
    path: 'agreement/nopwd', //免密支付协议，在服务协议中有
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/noPwd').default);
        },
        'realNameAuthView',
      );
    },
    onEnter: () => {
    },
  },
  {
    path: 'agreement/payqrcode', //付款码服务协议
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          cb(null, require('VIEW/agreement/payQrCode').default);
        },
        'realNameAuthView',
      );
    },
    onEnter: () => {
    },
  },
];




// WEBPACK FOOTER //
// ./src/route/agreement/agreementRedux.js